import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=12ddf1da&"
import script from "./MenuItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./MenuItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=12ddf1da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports